import React, { PropsWithChildren } from 'react';
import { pdpC14sDeflistStyle } from './pdp-c14s-list.style';

export const PdpC14sList: React.FC<PropsWithChildren> = ({ children }) => {
  return <dl className={pdpC14sDeflistStyle}>{children}</dl>;
};
